import {NOW_UI_EVENT} from '../constants';

export function emitNowUiEvent(type, detail) {
	if (!window.__ENABLE_NOW_UI_EVENT__) return;
	const event = new CustomEvent(NOW_UI_EVENT, {
		composed: true,
		bubbles: true,
		detail: {
			type,
			...detail
		}
	});
	document.dispatchEvent(event);
}
